import React from 'react';
import { connect } from 'react-redux';
import {
    fetchTiposPublicacionAdm,
    setTiposPublicacion,
    setTiposGrupoPlanes,
    setFiltroTiposPublicacion,
    resetSetTiposPublicaciones,
    resetValueChecked
} from '../../actions/tiposPublicacionActions';
import TipoPublicacionesListItem from './TipoPublicacionesListItem';
import ReactPaginate from 'react-paginate';
import FiltroTipoPublicaciones from './FiltroTipoPublicaciones';
import { setGrupoPlanes } from '../../actions/planesActions';
import { editando, limpiarFiltros } from '../../actions/generalActios';
import BigSpinner from '../General/BigSpinner';
import BtnToggleFilter from '../General/Filter/BtnToggleFilter';
import { useNavigate } from 'react-router-dom';

// Wrapper para usar hooks en class component
function ListTipoPublicacionesWrapper(props) {
    const navigate = useNavigate();
    return <ListTipoPublicaciones {...props} navigate={navigate} />;
}

class ListTipoPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onFilter: this.props.filtro?.onFilter ?? false,
            hideNoHayTipos: false,
            pageSize: 10,
            page: this.props.filtro?.numeroPagina ?? 1,
            descripcion: this.props.filtro?.descripcion ?? ""
        };
        this.INITIAL_REQUEST = {
            descripcion: "",
            PageSize: 10,
            Page: 1
        };
    }

    // Callback para que el switch haga fetch con el estado del filtro
    onBuscarConEstado = (estado) => {
        const params = {
            Page: this.props.filtro?.numeroPagina ?? 1,
            PageSize: this.state.pageSize,
            Estado: estado,
            descripcion: this.props.filtro?.descripcion ?? ""
        };
        this.props.fetchTiposPublicacionAdm(params);
    }

    handleEstadoActualizado = (codigo, nuevoEstado) => {
        // Actualiza el estado localmente en el store manteniendo la estructura { elementos, total, page }
        const tiposPublicacionesObj = this.props.tiposPublicacionObj || {};
        const elementos = [...(tiposPublicacionesObj.elementos || [])];
        const idx = elementos.findIndex(tp => tp.codigo === codigo);
        if (idx !== -1) {
            elementos[idx] = { ...elementos[idx], estado: nuevoEstado };
            const actualizado = {
                ...tiposPublicacionesObj,
                elementos
            };
            this.props.setTiposPublicacion(actualizado);
        }

        // Nuevo comportamiento solicitado:
        // - Si HAY un estado seteado en el filtro (p. ej. buscar por ACTIVO o DESHABILITADO), entonces
        //   tras el cambio por switch se debe refrescar la lista (fetch) usando el estado del filtro.
        // - Si NO hay ning�n estado en el filtro (filtro.estado es null/undefined), entonces
        //   solamente actualizamos localmente la lista y NO disparamos un fetch.

        const filtroEstado = (typeof this.props.filtro?.estado !== 'undefined' && this.props.filtro.estado !== null)
            ? this.props.filtro.estado
            : null;

        if (filtroEstado !== null) {
            // Rehacer la b�squeda usando el estado que est� persistido en el filtro
            const params = {
                Page: this.props.filtro?.numeroPagina ?? 1,
                PageSize: this.state.pageSize,
                Estado: filtroEstado
            };

            this.props.fetchTiposPublicacionAdm(params);
        }
    }

    componentDidMount() {

        // Si el filtro tiene estado, lo usa; si no, manda null (mostrar todos)
        let estadoEnviar = (typeof this.props.filtro?.estado !== 'undefined' && this.props.filtro.estado !== null)
            ? this.props.filtro.estado
            : null;
        this.busquedaTiposPublicacion({
            Page: this.state.page,
            PageSize: this.state.pageSize,
            Estado: estadoEnviar
        });
    }

    busquedaTiposPublicacion = (request) => {
        // Preferir el Estado que venga en el request (cuando el caller lo pasa expl�citamente,
        // por ejemplo desde el bot�n "Limpiar") y si no, tomarlo desde el filtro en el store.
        let estadoEnviar = null;
        if (request && Object.prototype.hasOwnProperty.call(request, 'Estado')) {
            estadoEnviar = request.Estado;
        } else {
            estadoEnviar = (typeof this.props.filtro?.estado !== 'undefined' && this.props.filtro.estado !== null)
                ? this.props.filtro.estado
                : null;
        }

        this.props.fetchTiposPublicacionAdm({
            ...request,
            Estado: estadoEnviar
        });

        // Guardar filtro en Redux: mantener otras propiedades del filtro actual y actualizar
        // numeroPagina/Estado/descripcion seg�n lo que se envi�.
        const newFiltro = {
            ...this.props.filtro,
            ...this.INITIAL_REQUEST,
            onFilter: this.state.onFilter,
            Estado: estadoEnviar,
            descripcion: request?.descripcion ?? this.props.filtro?.descripcion ?? "",
            numeroPagina: request?.Page ?? this.props.filtro?.numeroPagina ?? 1
        };

        this.props.setFiltroTiposPublicacion(newFiltro);
    }

    buscarConFiltro = () => {
        this.props.fetchTiposPublicacionAdm(
            this.props.filtro?.descripcion ?? "",
            this.INITIAL_REQUEST.PageSize,
            this.INITIAL_REQUEST.Page,
        );

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }



    setFilter = (e) => {
        e.preventDefault();
        this.setState({ onFilter: !this.state.onFilter });
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        let estadoEnviar = (typeof this.props.filtro?.estado !== 'undefined' && this.props.filtro.estado !== null)
            ? this.props.filtro.estado
            : null;

        let params = {
            Page: selectedPage,
            PageSize: this.state.pageSize,
            descripcion: this.props.filtro.descripcion,
            Estado: estadoEnviar
        };

        this.props.fetchTiposPublicacionAdm(params);
        this.props.setFiltroTiposPublicacion({ ...this.props.filtro, numeroPagina: selectedPage, Estado: estadoEnviar });
    };

    onTipoChange = (cantidadTipos) => {
        if (cantidadTipos > 0) {
            this.setState({ hideNoHayTipos: true });
        } else {
            this.setState({ hideNoHayTipos: false });
        }
    }

    onTipo = (id, tipo) => {
        const pk = tipo.idTipoPublicacion ?? tipo.IdTipoPublicacion ?? id;
        this.props.editando(false);
        this.props.setTiposGrupoPlanes(null)
        this.props.setGrupoPlanes();
        this.props.setTiposPublicacion({
            id: pk,
            comision: tipo.comision,
            descripcion: tipo.descripcion,
            cantidadCuotas: tipo.cantidadCuotas
        });
        this.props.navigate(`/Tipo/Publicaciones/Editar/${pk}`);
    }

    goToNuevo = () => {
        this.props.resetSetTiposPublicaciones();
        this.props.editando(false);
        this.props.setGrupoPlanes();
        this.props.resetValueChecked();
        this.props.navigate(`/Tipo/Publicaciones/Nuevo`);
    }

    onSubmit = async (event) => {
        event.preventDefault();
    }

    handleShowFilter = (value) => {
        this.setState({ onFilter: value });
        this.props.setFiltroTiposPublicacion({ ...this.props.filtro, onFilter: value });
    }


    render() {
        let btnFilterText = this.state.onFilter ? "Ocultar" : "Mostrar Filtro";
        let tiposPublicaciones =
            !Array.isArray(this.props.tiposPublicaciones) ? [] : this.props.tiposPublicaciones;

        return (
            <div>
                <div className="row align-items-center justify-content-between page-titles admin-page-heading">

                    <div className="col-12 col-sm-6">
                        <h3 className="text-themecolor color-rojo-megatone mb-0">Tipo de publicación</h3>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">Administrá comisiones y asociación a grupos de planes.</p>
                    </div>

                    <div className="col-12 col-sm-6 mt-2 mt-sm-0 button-group text-end">

                        <button
                            type="button"
                            onClick={this.goToNuevo}
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle" /> Crear
                        </button>

                        <BtnToggleFilter
                            show={this.state.onFilter}
                            handleShow={() => this.handleShowFilter(!this.state.onFilter)}
                        />
                    </div>
                </div>

                <div hidden={!this.state.onFilter}>
                    <FiltroTipoPublicaciones updateParams={this.busquedaTiposPublicacion} />
                </div>

                <div hidden={!this.state.hideNoHayTipos}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">No hay publicaciones</h5>
                </div>

                {this.props.loadingTiposPublicacion ? (
                    <BigSpinner />
                ) : (
                    <>
                        <div className="admin-list-stack">
                            {
                                tiposPublicaciones.length > 0 ?
                                    tiposPublicaciones.map((tipoPublicacion, index) => {
                                        return (
                                            <TipoPublicacionesListItem
                                                key={tipoPublicacion.codigo ?? index}
                                                codigo={tipoPublicacion.codigo}
                                                descripcion={tipoPublicacion.descripcion}
                                                comision={tipoPublicacion.comision}
                                                cantidadGrupoPlanes={tipoPublicacion.cantidadGrupoPlanes}
                                                cantidadPublicaciones={tipoPublicacion.cantidadPublicaciones}
                                                estado={tipoPublicacion.estado}
                                                filtro={this.props.filtro}
                                                onEdit={() => this.onTipo(tipoPublicacion.codigo, tipoPublicacion)}
                                                onEstadoActualizado={this.handleEstadoActualizado}
                                                onBuscarConEstado={this.onBuscarConEstado}
                                            />
                                        );
                                    })
                                    : null
                            }
                        </div>
                        <div className="d-flex justify-content-center">
                            <ReactPaginate
                                previousLabel={"Anterior"}
                                nextLabel={"Siguiente"}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={Math.ceil(this.props.cantidadTotal / this.state.pageSize)}
                                marginPagesDisplayed={10}
                                pageRangeDisplayed={10}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.props.filtro?.numeroPagina ?
                                    this.props.filtro.numeroPagina - 1 : 0}
                            />
                        </div>
                    </>
                )}
            </div>
        );
    }
}


const mapStateToProps = state => {
    const tp = state.tiposPublicacion?.tiposPublicaciones ?? {};
    const elementos =
        Array.isArray(tp?.elementos) ? tp.elementos :
            Array.isArray(tp?.Elementos) ? tp.Elementos :
                Array.isArray(tp?.content) ? tp.content :
                    Array.isArray(tp?.Content) ? tp.Content : [];
    return {
    tiposPublicaciones: elementos,
    loadingTiposPublicacion: state.tiposPublicacion.loadingTiposPublicacion,
    cantidadTotal: tp?.total ?? tp?.Total ?? tp?.cantidadTotal ?? tp?.CantidadTotal ?? elementos.length,
    numeroPagina: tp?.page ?? tp?.Page ?? tp?.numeroPagina ?? tp?.NumeroPagina ?? 1,
    filtro: state.tiposPublicacion.filtro,
    isFilterClear: state.general.limpiar.sellers,
    emptyFilters: state.general.limpiar,
    };
};

export default connect(mapStateToProps, {
    fetchTiposPublicacionAdm,
    setTiposGrupoPlanes,
    setTiposPublicacion,
    setGrupoPlanes,
    editando,
    setFiltroTiposPublicacion,
    limpiarFiltros,
    resetSetTiposPublicaciones,
    resetValueChecked,
})(ListTipoPublicacionesWrapper); 